module.exports = __webpack_public_path__ + "img/nivel_luz_red.5374568e.svg";